module.exports = __webpack_public_path__ + "img/hernan-ferraro.5772f343.jpg";